<template>
    <div class="wrap">
        <div class="page_title"><b>案件分析</b></div>
        <div class="search_box public_box">
            <el-form ref="navFormRef" :inline="true" :model="queryForm">
                <el-form-item label="录入案件时间：">
                    <el-row style="width: 350px">
                        <el-col :span="11">
                            <el-date-picker placeholder="请选择日期" clearable v-model="queryForm.startTime" type="date" value-format="yyyy-MM-dd" style="width: 100%"> </el-date-picker>
                        </el-col>
                        <el-col class="line" style="text-align: center" :span="2">至</el-col>
                        <el-col :span="11">
                            <el-date-picker placeholder="请选择日期" clearable v-model="queryForm.endTime" type="date" value-format="yyyy-MM-dd" style="width: 100%"> </el-date-picker>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 10px" @click="searchCasePage">查 询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="public_box">
            <div class="charts autoC">
                <div class="card">
                    <p class="chart_title">一、诉讼案件区域及类型</p>
                    <div id="chart1" class="chart_box"></div>
                    <!-- <p class="chart_txt">口径：所有类型案件（6月-至今）</p> -->
                    <p class="chart_txt">口径：所有类型案件</p>
                    <el-table class="chart_table" :data="chart1Data" max-height="330" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="itemName" label="区域"> </el-table-column>
                        <el-table-column prop="itemNum1" label="新商保重复索赔"> </el-table-column>
                        <el-table-column prop="itemNum2" label="索赔超保单项目金额"> </el-table-column>
                        <el-table-column prop="itemNum3" label="保险责任争议"> </el-table-column>
                        <el-table-column prop="itemNum4" label="其他"> </el-table-column>
                        <el-table-column prop="allNum" label="总计"> </el-table-column>
                    </el-table>
                </div>
                <div class="card" v-if="0">
                    <p class="chart_title">二、区域胜诉情况</p>
                    <div id="chart2" class="chart_box"></div>
                    <!-- <p class="chart_txt">口径：所有系统结案案件（6月-至今）、胜诉案件：我司受理费/法院受理费 < 50%</p> -->
                    <p class="chart_txt">口径：所有系统结案案件、胜诉案件：我司受理费/法院受理费 < 50%</p>
                </div>
                <div class="card">
                    <p class="chart_title">二、案件结案情况</p>
                    <div id="closeCaseUserChart" class="chart_box"></div>
                    <div id="closeCaseLawFirmChart" class="chart_box"></div>
                    <!-- show-summary -->
                    <el-table class="chart_table bgc1" :data="closeCaseUserData" :span-method="(e) => objectSpanMethod(e, 'closeCaseUserData')" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="处理方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人" :resizable="false"> </el-table-column>
                        <el-table-column prop="closeNum" label="结案件数（累计）" :resizable="false"> </el-table-column>
                        <el-table-column prop="closeMonthNum" label="结案件数（月）" :resizable="false"> </el-table-column>
                        <el-table-column prop="closeMonthWeek" label="结案件数（周）" :resizable="false"></el-table-column>
                        <el-table-column prop="lawsuitAmount" label="诉讼金额" :resizable="false"> </el-table-column>
                        <el-table-column prop="compensationAmount" label="结案金额" :resizable="false"> </el-table-column>
                        <el-table-column prop="impairmentAmount" label="减损金额" :resizable="false"> </el-table-column>
                        <!-- <el-table-column prop="winningRate" label="胜诉率"> </el-table-column> -->
                        <el-table-column prop="mediationRate" label="调解率" :resizable="false"> </el-table-column>
                    </el-table>
                    <el-table class="chart_table bgc1 hideTableHeader" :data="closeCaseHe1" v-show="closeCaseUserData.length > 0" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="处理方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人" :resizable="false"> </el-table-column>
                        <el-table-column prop="closeNum" label="结案件数（累计）" :resizable="false"> </el-table-column>
                        <el-table-column prop="closeMonthNum" label="结案件数（月）" :resizable="false"> </el-table-column>
                        <el-table-column prop="closeMonthWeek" label="结案件数（周）" :resizable="false"></el-table-column>
                        <el-table-column prop="lawsuitAmount" label="诉讼金额" :resizable="false"> </el-table-column>
                        <el-table-column prop="compensationAmount" label="结案金额" :resizable="false"> </el-table-column>
                        <el-table-column prop="impairmentAmount" label="减损金额" :resizable="false"> </el-table-column>
                        <!-- <el-table-column prop="winningRate" label="胜诉率"> </el-table-column> -->
                        <el-table-column prop="mediationRate" label="调解率" :resizable="false"> </el-table-column>
                    </el-table>
                    <el-table class="chart_table bgc2 hideTableHeader" :data="closeCaseLawFirmData" v-show="closeCaseLawFirmData.length > 0" :span-method="(e) => objectSpanMethod(e, 'closeCaseLawFirmData')" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="处理方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人"> </el-table-column>
                        <el-table-column prop="closeNum" label="结案件数（累计）"> </el-table-column>
                        <el-table-column prop="closeMonthNum" label="结案件数（月）"> </el-table-column>
                        <el-table-column prop="closeMonthWeek" label="结案件数（周）"> </el-table-column>
                        <el-table-column prop="lawsuitAmount" label="诉讼金额"> </el-table-column>
                        <el-table-column prop="compensationAmount" label="结案金额"> </el-table-column>
                        <el-table-column prop="impairmentAmount" label="减损金额"> </el-table-column>
                        <!-- <el-table-column prop="winningRate" label="胜诉率"> </el-table-column> -->
                        <el-table-column prop="mediationRate" label="调解率"> </el-table-column>
                    </el-table>
                    <el-table class="chart_table bgc2 hideTableHeader" :data="closeCaseHe1_1" v-show="closeCaseLawFirmData.length > 0" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="处理方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人"> </el-table-column>
                        <el-table-column prop="closeNum" label="结案件数（累计）"> </el-table-column>
                        <el-table-column prop="closeMonthNum" label="结案件数（月）"> </el-table-column>
                        <el-table-column prop="closeMonthWeek" label="结案件数（周）"> </el-table-column>
                        <el-table-column prop="lawsuitAmount" label="诉讼金额"> </el-table-column>
                        <el-table-column prop="compensationAmount" label="结案金额"> </el-table-column>
                        <el-table-column prop="impairmentAmount" label="减损金额"> </el-table-column>
                        <!-- <el-table-column prop="winningRate" label="胜诉率"> </el-table-column> -->
                        <el-table-column prop="mediationRate" label="调解率"> </el-table-column>
                    </el-table>

                    <!-- <p class="chart_txt">口径：减损金额=诉讼金额-结案金额；胜诉率=胜诉案件数/判决案件件数；调解率：调解案件数/结案案件件数</p> -->
                    <p class="chart_txt">口径：减损金额=诉讼金额-结案金额；调解率：调解案件数/结案案件件数</p>
                </div>
                <div class="card">
                    <p class="chart_title">三、处理中案件情况（及时更新）</p>
                    <el-table class="chart_table bgc1 bgcHeaderFooter" :data="caseUserData" :span-method="(e) => objectSpanMethod(e, 'caseUserData')" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="委托方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人" :resizable="false"> </el-table-column>
                        <el-table-column prop="activeNum" label="活跃案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="hangUpNum" label="挂起案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="inputNum" label="录入处理中案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="firstNum" label="一审中案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="secondNum" label="二审中案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="reviewNum" label="再审中案件数" :resizable="false"> </el-table-column>
                    </el-table>
                    <el-table class="chart_table bgc1 hideTableHeader bgcHeaderFooter" :data="closeCaseHe2" v-show="caseUserData.length > 0" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="委托方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人" :resizable="false"> </el-table-column>
                        <el-table-column prop="activeNum" label="活跃案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="hangUpNum" label="挂起案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="inputNum" label="录入处理中案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="firstNum" label="一审中案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="secondNum" label="二审中案件数" :resizable="false"> </el-table-column>
                        <el-table-column prop="reviewNum" label="再审中案件数" :resizable="false"> </el-table-column>
                    </el-table>

                    <el-table class="chart_table bgc2 hideTableHeader bgcHeaderFooter" :data="caseLawFirmData" v-show="caseLawFirmData.length > 0" :span-method="(e) => objectSpanMethod(e, 'caseLawFirmData')" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="委托方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人"> </el-table-column>
                        <el-table-column prop="activeNum" label="活跃案件数"> </el-table-column>
                        <el-table-column prop="hangUpNum" label="挂起案件数"> </el-table-column>
                        <el-table-column prop="inputNum" label="录入处理中案件数"> </el-table-column>
                        <el-table-column prop="firstNum" label="一审中案件数"> </el-table-column>
                        <el-table-column prop="secondNum" label="二审中案件数"> </el-table-column>
                        <el-table-column prop="reviewNum" label="再审中案件数"> </el-table-column>
                    </el-table>
                    <el-table class="chart_table bgc2 hideTableHeader bgcHeaderFooter" :data="closeCaseHe2_1" v-show="caseLawFirmData.length > 0" border style="width: 100%; margin-top: 20px">
                        <el-table-column prop="handler" label="委托方式" width="140"> </el-table-column>
                        <el-table-column prop="name" label="处理人"> </el-table-column>
                        <el-table-column prop="activeNum" label="活跃案件数"> </el-table-column>
                        <el-table-column prop="hangUpNum" label="挂起案件数"> </el-table-column>
                        <el-table-column prop="inputNum" label="录入处理中案件数"> </el-table-column>
                        <el-table-column prop="firstNum" label="一审中案件数"> </el-table-column>
                        <el-table-column prop="secondNum" label="二审中案件数"> </el-table-column>
                        <el-table-column prop="reviewNum" label="再审中案件数"> </el-table-column>
                    </el-table>
                    <p class="chart_txt"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    data() {
        return {
            queryForm: {
                startTime: '',
                endTime: '',
                monthTime: '',
                weekTime: ''
            },
            closeCaseLawFirmData: [],
            closeCaseUserData: [],
            caseLawFirmData: [],
            caseUserData: [],
            regionType: [],
            closeCaseHe1: [],
            closeCaseHe1_1: [],
            closeCaseHe2: [],
            closeCaseHe2_1: [],
            chart1: null,
            chart1Data: []
        };
    },
    mounted() {
        window.addEventListener('resize', function () {
            this.chart1 && this.chart1.resize();
        });
        // 设置默认近90天的时间范围
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 90);
        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];
        // 同时设置queryForm和对应变量，确保日期选择器正确回显
        this.queryForm.startTime = startDateStr;
        this.queryForm.endTime = endDateStr;
        this.searchCasePage();
    },
    methods: {
        searchCasePage() {
            // 仅在日期存在且未带时间部分时才拼接时间，避免重复拼接
            if (this.queryForm.startTime && this.queryForm.startTime.length === 10) {
                this.queryForm.startTime = this.queryForm.startTime + ' 00:00:00';
            }
            if (this.queryForm.endTime && this.queryForm.endTime.length === 10) {
                this.queryForm.endTime = this.queryForm.endTime + ' 23:59:59';
            }
            this.queryRegionType();
            this.queryCloseCaseUser();
            this.queryCloseCaseLawFirm();
            this.queryCaseLawuser();
            this.queryCaseLawFirm();
            this.closeCaseUserChartData();
            this.closeCaseLawFirmChartData();
        },
        // 案件结案图表-用户
        closeCaseUserChartData() {
            this.instance.post('/lawsuitCase/statistics/closeCaseUserChart', this.queryForm).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    if (data.data) {
                        // this.closeCaseUserChartData = data.data;
                        let tmpChartData = data.data;

                        let xAxisData = [];
                        let seriesData = [];
                        let legendArr = ['判决', '调解', '撤诉', '调解率'];

                        // 首先创建seriesData数组，根据legendArr设置每个系列的类型
                        legendArr.forEach((res) => {
                            seriesData.push({
                                name: res,
                                type: res == '调解率' ? 'line' : 'bar',
                                // barWidth: 50,
                                data: [],
                                yAxisIndex: res == '调解率' ? 1 : 0
                            });
                        });

                        // 遍历实际数据，构建xAxisData并填充seriesData
                        tmpChartData.forEach((item) => {
                            xAxisData.push(item.itemName);

                            // 为每个系列添加对应的数据
                            seriesData[0].data.push(item.itemNum1); // 判决
                            seriesData[1].data.push(item.itemNum2); // 调解
                            seriesData[2].data.push(item.itemNum3); // 撤诉
                            seriesData[3].data.push(item.itemRatio); // 调解率
                        });

                        this.caseRegionTypeChart(legendArr, xAxisData, seriesData, 'closeCaseUserChart');
                    }
                }
            });
        },
        // 案件结案图表-律师
        closeCaseLawFirmChartData() {
            this.instance.post('/lawsuitCase/statistics/closeCaseLawFirmChart', this.queryForm).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    if (data.data) {
                        // this.closeCaseUserChartData = data.data;
                        let tmpChartData = data.data;

                        let xAxisData = [];
                        let seriesData = [];
                        let legendArr = ['判决', '调解', '撤诉', '调解率'];

                        // 首先创建seriesData数组，根据legendArr设置每个系列的类型
                        legendArr.forEach((res) => {
                            seriesData.push({
                                name: res,
                                type: res == '调解率' ? 'line' : 'bar',
                                // barWidth: 50,
                                data: [],
                                yAxisIndex: res == '调解率' ? 1 : 0
                            });
                        });

                        // 遍历实际数据，构建xAxisData并填充seriesData
                        tmpChartData.forEach((item) => {
                            xAxisData.push(item.itemName);

                            // 为每个系列添加对应的数据
                            seriesData[0].data.push(item.itemNum1); // 判决
                            seriesData[1].data.push(item.itemNum2); // 调解
                            seriesData[2].data.push(item.itemNum3); // 撤诉
                            seriesData[3].data.push(item.itemRatio); // 调解率
                        });

                        this.caseRegionTypeChart(legendArr, xAxisData, seriesData, 'closeCaseLawFirmChart');
                    }
                }
            });
        },
        // 查询区域类型统计
        queryRegionType() {
            this.instance.post('/lawsuitCase/statistics/regionType', this.queryForm).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    if (data.data) {
                        this.chart1Data = data.data;
                        this.regionType = data.data;

                        let xAxisData = [];
                        let seriesData = [];
                        let legendArr = ['新商保重复索赔', '索赔超保单项目金额', '保险责任争议', '其他'];
                        legendArr.forEach((res) => {
                            seriesData.push({
                                name: res,
                                type: 'bar',
                                stack: 'bar',
                                // barWidth: 50,
                                data: []
                            });
                        });

                        this.regionType.forEach((item, index) => {
                            xAxisData.push(item.itemName);
                            seriesData.forEach((resItem, resIndex) => {
                                resItem.data.push(item['itemNum' + (resIndex + 1)]);
                            });
                        });

                        this.caseRegionTypeChart(legendArr, xAxisData, seriesData, 'chart1');
                    }
                }
            });
        },
        // 查询案件结案情况（用户）
        queryCloseCaseUser() {
            this.instance.post('/lawsuitCase/statistics/closeCaseUser', this.queryForm).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data.itemList) {
                    this.closeCaseUserData = data.data.itemList;
                    // 添加判空检查，防止TypeError
                    if (this.closeCaseUserData && this.closeCaseUserData.length > 0) {
                        this.closeCaseUserData[0].handler = '员工出庭';
                    }
                    if (data.data.total) {
                        this.closeCaseHe1 = [data.data.total];
                        // Add null/undefined check to prevent TypeError
                        if (this.closeCaseHe1 && this.closeCaseHe1.length > 0) {
                            this.closeCaseHe1[0].handler = '合计';
                        }
                        this.closeCaseHe1[0].name = '';
                    } else {
                        this.closeCaseHe1 = [];
                    }
                }
            });
        },
        // 查询案件结案情况（律所）
        queryCloseCaseLawFirm() {
            this.instance.post('/lawsuitCase/statistics/closeCaseLawFirm', this.queryForm).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data.itemList) {
                    this.closeCaseLawFirmData = data.data.itemList;
                    // 添加判空检查，防止TypeError
                    if (this.closeCaseLawFirmData && this.closeCaseLawFirmData.length > 0) {
                        this.closeCaseLawFirmData[0].handler = '律师出庭';
                    }
                    if (data.data.total) {
                        this.closeCaseHe1_1 = [data.data.total];
                        this.closeCaseHe1_1[0].handler = '合计';
                        this.closeCaseHe1_1[0].name = '';
                    } else {
                        this.closeCaseHe1_1 = [];
                    }
                }
            });
        },
        // 查询处理案件情况（用户）
        queryCaseLawuser() {
            this.instance.post('/lawsuitCase/statistics/handlerCaseUser', this.queryForm).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data.itemList) {
                    this.caseUserData = data.data.itemList || [];
                    // 添加判空检查，防止TypeError
                    if (this.caseUserData && this.caseUserData.length > 0) {
                        this.caseUserData[0].handler = '员工出庭';
                    }
                    if (data.data.total) {
                        this.closeCaseHe2 = [data.data.total];
                        this.closeCaseHe2[0].handler = '合计';
                        this.closeCaseHe2[0].name = '';
                    } else {
                        this.closeCaseHe2 = [];
                    }
                }
            });
        },
        // 查询处理案件情况（律所）
        queryCaseLawFirm() {
            this.instance.post('/lawsuitCase/statistics/handlerCaseLawFirm', this.queryForm).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data.itemList) {
                    this.caseLawFirmData = data.data.itemList || [];
                    if (this.caseLawFirmData && this.caseLawFirmData.length > 0) {
                        this.caseLawFirmData[0].handler = '律师出庭';
                    }
                    if (data.data.total) {
                        this.closeCaseHe2_1 = [data.data.total];
                        this.closeCaseHe2_1[0].handler = '合计';
                        this.closeCaseHe2_1[0].name = '';
                    } else {
                        this.closeCaseHe2_1 = [];
                    }
                }
            });
        },
        // 案件总量情况 - 柱状图
        caseRegionTypeChart(legendArr, xAxisData, seriesData, elIdStr) {
            // 根据不同的图表元素ID设置不同的标题
            let titleText = null;
            switch (elIdStr) {
                case 'closeCaseUserChart':
                    titleText = '案件结案情况-员工';

                    break;
                case 'closeCaseLawFirmChart':
                    titleText = '案件结案情况-律所';
                    break;
            }

            const grid = {
                left: 100,
                right: 100,
                top: titleText ? 80 : 50, // 如果有标题，调整top值以避免重叠
                bottom: elIdStr == 'closeCaseLawFirmChart' ? 100 : 80
            };

            var option = {
                title: titleText
                    ? {
                          text: titleText,
                          left: 'center',
                          textStyle: {
                              fontSize: 16,
                              fontWeight: 'bold'
                          }
                      }
                    : null,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    // selectedMode: false
                    data: legendArr,
                    top: titleText ? 40 : 10 // 如果有标题，调整legend位置
                },
                grid,
                yAxis: [
                    {
                        type: 'value',
                        name: '案件数量',
                        position: 'left'
                    },
                    elIdStr == 'closeCaseUserChart' || elIdStr == 'closeCaseLawFirmChart'
                        ? {
                              type: 'value',
                              name: '调解率(%)',
                              position: 'right',
                              axisLabel: {
                                  formatter: '{value}%'
                              },
                              splitLine: {
                                  show: false
                              }
                          }
                        : {}
                ],
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        rotate: 45, // 设置X轴标签倾斜45度
                        interval: 0 // 如果需要全部显示标签，则设置interval为0
                    },
                    data: xAxisData
                },
                series: seriesData,
                devicePixelRatio: window.devicePixelRatio // 使用设备的像素比
            };

            let tmpDom = document.getElementById(elIdStr);
            if (tmpDom) {
                this.chart1 = echarts.init(tmpDom);
                this.chart1.setOption(option);
                // setTimeout(() => {
                //     this.chart1.resize();
                // }, 30);
            }
        },
        objectSpanMethod(event, dataStr) {
            if (event.columnIndex === 0) {
                const length = this[dataStr].length;
                if (event.rowIndex < length) {
                    if (event.rowIndex === 0) {
                        return {
                            rowspan: this[dataStr].length,
                            colspan: 1
                        };
                    } else {
                        // 对于其他行，首列不渲染
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search_box {
    padding-bottom: 0 !important;
}
.public_box {
    margin-top: 20px;
    padding: 20px;
    min-width: 900px;
    .charts {
        width: 900px;
        .card {
            width: 900px;
            margin-bottom: 20px;
            .chart_title {
                font-size: 16px;
                font-weight: bold;
                margin-top: 40px;
            }
            .chart_box {
                width: 100%;
                height: 300px;
                border: 1px solid #a3a1a1;
                margin: 20px 0;
                padding-top: 10px;
            }
            .chart_table {
                margin: 20px 0;
            }
            // el-table__empty-text
            .bgc1,
            .bgc2 {
                border-color: black;
                border-right: 1px solid black;
                color: black;
                /deep/.cell {
                    border-right-color: black;
                    border-bottom-color: black;
                }

                /deep/.el-table__body-wrapper {
                    tr {
                        td,
                        th {
                            border-right: 1px solid black;
                            border-bottom: 1px solid black;
                        }
                        td:last-child,
                        th:last-child {
                            border-right: none !important;
                        }
                    }
                }

                /deep/.el-table__footer-wrapper * {
                    border-color: black;
                    color: black;
                }

                // header/footer 最后列
                /deep/.el-table__header-wrapper,
                /deep/.el-table__footer-wrapper {
                    .has-gutter {
                        tr {
                            th {
                                color: black;
                                border-color: black;
                                border-right: 1px solid black;
                                background: #fff;
                            }
                            .is-leaf:nth-child(9) {
                                border-right: 0;
                            }
                        }
                    }
                }
            }

            /deep/ .el-table--border::after,
            /deep/ .el-table--group::after,
            /deep/ .el-table::before {
                display: none;
            }

            .bgc1 {
                /deep/ .el-table__body-wrapper,
                /deep/ .el-table__footer-wrapper {
                    * {
                        background-color: #ffe699;
                    }
                }
            }
            .bgc2 {
                // border-bottom: 1px solid black;
                /deep/ .el-table__body-wrapper,
                /deep/ .el-table__footer-wrapper {
                    * {
                        background-color: #bdd7ee;
                    }
                }
            }
            .bgcHeaderFooter {
                // header/footer 最后列
                /deep/.el-table__header-wrapper,
                /deep/.el-table__footer-wrapper {
                    .has-gutter {
                        tr {
                            .is-leaf:nth-child(8) {
                                border-right: 0;
                            }
                        }
                    }
                }
            }
            .hideTableHeader {
                margin-top: -21px !important;
                /deep/.el-table__header {
                    display: none;
                }
            }
        }
        .card:last-child {
            margin-bottom: 0;
        }
    }
}
</style>